import React, { FunctionComponent } from "react";
import { ThemeProvider } from "emotion-theming";
import PropTypes, { InferProps } from "prop-types";
import themeConfig from "theme/config";

const propTypes = {
    children: PropTypes.node.isRequired,
};

type Props = InferProps<typeof propTypes>;

const ThemeWrapper: FunctionComponent<Props> = ({ children }) => {
    const baseProperties = themeConfig();

    return <ThemeProvider theme={baseProperties}>{children}</ThemeProvider>;
};

ThemeWrapper.propTypes = propTypes;

export default ThemeWrapper;
